import { MappingContext } from '@decisions/server/DecisionsFramework/Design/Flow/Service/MappingContext';

import {
  getSampleCategories,
  getSampleCategory,
  searchSamples,
  getSamples,
  getSampleEntityById,
} from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Samples/SampleService';
import {SampleCategory} from "@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Samples/SampleCategory";
import {SampleForTree} from "@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Samples/SampleForTree";

export interface ISamplesApiFactory {
  getCategories: () => Promise<SampleCategory[]>;
  getCategory: (sampleId: string) => Promise<SampleCategory>;
  
  search: (searchCriteria: string) => Promise<SampleForTree[]>;
  getByCategory: (category: string, limitCount?: number, pageIndex?: number) => Promise<SampleForTree[]>;
  getSample: (sampleId: string) => Promise<SampleForTree>;
}

export const SamplesApiFactory = (mappingContext: MappingContext) => ({
  getCategories: () => {
    return getSampleCategories({ mappingContext });
  },

  getCategory: (sampleId: string) => {
    if (mappingContext) {
      return getSampleCategory({ mappingContext, sampleId });
    }
  },

  search: (searchCriteria: string) => {
    if (mappingContext) {
      return searchSamples({ mappingContext, searchCriteria });
    }
  },

  getByCategory: (category: string, limitCount?: number, pageIndex: number = 0) => {
    if (mappingContext) {
      return getSamples({ mappingContext, category, limitCount, pageIndex });
    } else {
      return [];
    }
  },

  getSample: (sampleId: string) => {
      return getSampleEntityById({ sampleId });
  },
} as ISamplesApiFactory);
